<template>
  <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer justify-content-center gap-2">
          <button type="button" class="btn btn-primary btn-back custom-p-2" data-bs-dismiss="modal">لغو</button>
          <button type="button" class="btn btn-primary btn-submit-1 custom-p-2" @click="$emit('save')">ذخیره</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
  }
};
</script>
